import React from 'react';

const digitalMarketingPortfolioItems = [
  {
    id: 1,
    image: '/assets/images/digital-marketing/digital (1).jpg',
    title: 'Brand Growth & Performance Campaign',
    category: 'SEO & Performance Marketing',
    platform: 'Digital Campaign'
  },
  {
    id: 2,
    image: '/assets/images/digital-marketing/digital (2).jpg',
    title: 'Social Media Engagement Scale',
    category: 'Social Media Marketing',
    platform: 'SMM & Paid Ads'
  },

  {
    id: 5,
    image: '/assets/images/digital-marketing/digital (5).jpg',
    title: 'Omnichannel Brand Positioning',
    category: 'Brand Strategy',
    platform: 'Social Growth'
  },
  {
    id: 6,
    image: '/assets/images/digital-marketing/digital (6).jpg',
    title: 'E-Commerce Conversion Accelerator',
    category: 'Performance Ads',
    platform: 'ROI & Ad Scale'
  },
  {
    id: 7,
    image: '/assets/images/digital-marketing/digital (7).jpg',
    title: 'Content & Viral Outreach',
    category: 'Content Marketing',
    platform: 'Influencer & Social'
  },
  {
    id: 8,
    image: '/assets/images/digital-marketing/digital (8).jpg',
    title: 'Global Organic Traffic Boost',
    category: 'Organic Search Strategy',
    platform: 'SEO Strategy'
  },
  {
    id: 9,
    image: '/assets/images/digital-marketing/digital (9).jpg',
    title: 'High-Impact Brand Awareness',
    category: 'Creative Marketing',
    platform: 'Digital Outreach'
  },
  {
    id: 10,
    image: '/assets/images/digital-marketing/digital (10).jpg',
    title: 'Enterprise Revenue Generation',
    category: 'Full-Funnel Marketing',
    platform: 'Performance Marketing'
  }
];

function DigitalMarketingPortfolio() {
  const handleConsultationClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('digital-marketing-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="ecom-portfolio-section" id="digital-marketing-portfolio">
      <div className="container">
        {/* Section Header */}
        <div className="ecom-portfolio-header">
          <div className="ecom-portfolio-badge-row">
            <span className="ecom-portfolio-badge">Featured Campaigns & Results</span>
            <div className="ecom-portfolio-badge-line"></div>
          </div>

          <h2 className="ecom-portfolio-title">
            Our Digital Marketing Agency's <span className="text-red">Success Stories</span>
          </h2>

          <p className="ecom-portfolio-subtitle">
            Explore our curated showcase of high-performing digital marketing campaigns, SEO achievements, and revenue-multiplying strategies crafted for our global and local clients.
          </p>
        </div>

        {/* Portfolio Grid matching Website Design Portfolio */}
        <div className="ecom-portfolio-grid">
          {digitalMarketingPortfolioItems.map((item) => (
            <div key={item.id} className="ecom-portfolio-card" onClick={handleConsultationClick}>
              {/* Browser Window Frame Header */}
              <div className="ecom-portfolio-window-bar">
                <div className="ecom-window-dots">
                  <span className="ecom-dot dot-red"></span>
                  <span className="ecom-dot dot-yellow"></span>
                  <span className="ecom-dot dot-green"></span>
                </div>
                <span className="ecom-window-title">{item.platform}</span>
              </div>

              {/* Scrollable Image Frame */}
              <div className="ecom-portfolio-img-frame">
                <img
                  src={item.image}
                  alt={item.title}
                  className="ecom-portfolio-img"
                  loading="lazy"
                />

                {/* Hover Hint Overlay */}
                <div className="ecom-hover-hint">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="7 13 12 18 17 13" />
                    <polyline points="7 6 12 11 17 6" />
                  </svg>
                  <span>Auto-scrolling</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DigitalMarketingPortfolio;
